import { useMutation } from '@tanstack/react-query';

import { useToastStore } from '@pkg/components/Toast/useToastStore';
import { type MutationProfilesUpdateArgs } from '@pkg/graphql/codegen/graphql';
import { useQueryInvalidation } from '@pkg/hooks';

import { callProfileDetailsUpdate } from './request';
import { PROFILE_DETAILS_QUERY_KEY } from './useProfileDetails';

export function useProfileDetailsUpdate() {
    const { addToast } = useToastStore();
    // Invalidating the query will cause `useProfileDate()` to re-run,
    // returning the newly updated profile details.
    const invalidateWalletsCache = useQueryInvalidation([PROFILE_DETAILS_QUERY_KEY]);

    return useMutation({
        mutationFn: (params: MutationProfilesUpdateArgs) => callProfileDetailsUpdate({ variables: params }),
        retry: false,
        onMutate: () => {
            // TODO: Should we get rid of this? The mutation happens so
            // quickly that this just ends up looking like a bug. We should
            // instead just render a "loading spinner" next to each Profile
            // input while `isPending`.
            addToast({
                isLoader: true,
                message: 'Workin’ on it…',
            });
        },
        onSuccess: invalidateWalletsCache,
    });
}
